import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import moment from "moment";
import { useFormikContext } from "formik";

const BatchSelectionModal = ({
  isOpen,
  setIsOpen,
  batches = [],
  onSelect,
  heading = [],
  dynamicKey = "data",
}) => {
  const { values } = useFormikContext();
  const item_id = values?.tempRowData?.item_id;

  // const [heading, setHeading] = useState([]);
  // useEffect(() => {
  //   const data = localStorage.getItem("ModPermission");
  //   if (data) {
  //     const parsed = JSON.parse(data);
  //     const billingData = parsed.find((obj) => obj?.bill_create_batch_pop_up);
  //     if (billingData?.bill_create_batch_pop_up) {
  //       setHeading(billingData.bill_create_batch_pop_up);
  //     }
  //   }
  // }, []);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const rowRefs = useRef([]);

  const filteredBatches = batches.filter(
    (batch) =>
      !values?.[dynamicKey]?.some(
        (entry) =>
          entry.item_id === item_id &&
          entry.item_batch_number === batch.item_batch_number &&
          entry?.item_rack_location === batch?.item_rack_location
      )
  );
  console.log(batches, "gvsdfgdsgfdgdfgdfgdgdf");
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setSelectedIndex((prev) =>
        Math.min(prev + 1, filteredBatches.length - 1)
      );
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      onSelect(filteredBatches[selectedIndex]);
    } else if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      // setTimeout(() => rowRefs?.current?.focus(), 10); // Ensure modal is focused
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, selectedIndex]);

  useEffect(() => {
    if (rowRefs.current[selectedIndex]) {
      rowRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => {
          setIsOpen(false);
          setSelectedIndex(0);
        }}
      >
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60 z-40" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div
              tabIndex={0}
              className="bg-white w-[95%] mx-auto px-4 rounded-[8px] shadow-lg text-left overflow-auto h-[30vh] min-h-[25rem] z-50 focus:outline-none"
            >
              <div
                className="h-[61px]  flex items-center justify-between border-b"
                style={{ borderColor: "var(--slide-panel-border)" }}
              >
                <div
                  style={{
                    maxHeight: "32px",
                    color: "var(--slide-panel-h-fg)",
                    fontSize: "var(--stand-alone-label-fs)",
                    fontWeight: "var(--slide-panel-h-fw)",
                  }}
                  className="min-w-[75%] "
                >
                  Batch Number
                </div>
                <AddButton
                  onclkFn={() => {
                    setIsOpen(false);
                    // setProductDetails({ item_id: "" });
                  }}
                  icon={
                    <CloseIcon
                      width="12px"
                      height="12px"
                      fill="var(--close-button-fg)"
                    />
                  }
                  text={
                    <span>
                      Close <span className="opacity-50">(X)</span>{" "}
                    </span>
                  }
                  className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                />
              </div>
              <div
                style={{
                  maxHeight: `calc(100% - 61px)`,
                  minHeight: `5rem`,
                }}
                className="tab-container rounded-[8px] "
              >
                <table className="w-full border-collapse mt-0">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px] rounded-lg">
                      {heading
                        .filter((col) => col.enabled !== false)
                        .map((col, idx) => (
                          <th
                            style={{ minWidth: `${col?.minWidth}px` }}
                            key={idx}
                            className="px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                          >
                            <div
                              className="flex items-center gap-2 w-full text-wrap"
                              style={{
                                justifyContent:
                                  col?.alignment === "right"
                                    ? "flex-end"
                                    : col?.alignment === "center"
                                    ? "center"
                                    : "flex-start",
                              }}
                            >
                              {col?.label}
                            </div>
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBatches.map((batch, index) => (
                      <tr
                        ref={(el) => (rowRefs.current[index] = el)}
                        key={batch.item_batch_number || index}
                        className={`cursor-pointer transition-all ${
                          selectedIndex === index
                            ? "bg-primary text-white font-semibold"
                            : "hover:bg-[var(--create-table-row-hover-bg)] text-[var(--create-table-row-fg-color)]"
                        }  ${
                          index % 2 === 0
                            ? " bg-[var(--create-table-row-alt-bg)]"
                            : " bg-[var(--create-table-row-bg)]"
                        }   h-[48px]`}
                        onClick={() => {
                          onSelect(batch);
                          setSelectedIndex(0);
                          // setIsOpen(false);
                        }}
                      >
                        {heading
                          .filter((col) => col.enabled !== false)
                          .map((col, colIndex) => (
                            <td
                              style={{
                                minWidth: `${col?.minWidth}px`,
                                textAlign: col?.alignment, // Keep textAlign for normal text cells
                              }}
                              key={colIndex}
                              className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)]  whitespace-nowrap cursor-pointer"
                            >
                              {col?.value === "item_exp_date" ? (
                                (() => {
                                  const expDate = moment(batch[col.value]);
                                  const today = moment();
                                  const monthsDiff = expDate.diff(
                                    today,
                                    "months",
                                    true
                                  ); // fractional months

                                  let bgColor = "bg-[var(--pill-badge-red-bg)]";
                                  if (expDate.isBefore(today, "day")) {
                                    bgColor = "bg-[var(--pill-badge-red-bg)]"; // expired
                                  } else if (monthsDiff <= 3) {
                                    bgColor =
                                      "bg-[var(--pill-badge-yellow-bg)]"; // about to expire
                                  } else {
                                    bgColor = "bg-[var(--pill-badge-green-bg)]"; // safe
                                  }

                                  return (
                                    <div className="flex items-center gap-2">
                                      <span
                                        className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${bgColor}`}
                                      >
                                        {expDate.isValid()
                                          ? expDate.format("YYYY-MM-DD")
                                          : "--"}
                                      </span>
                                    </div>
                                  );
                                })()
                              ) : col?.value === "stock_status" ? (
                                <div className="flex items-center gap-2">
                                  <span
                                    className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${
                                      batch[col.value] === "In Stock"
                                        ? "bg-[var(--pill-badge-green-bg)]"
                                        : batch[col.value] === "Out of Stock"
                                        ? "bg-[var(--pill-badge-red-bg)]"
                                        : "bg-[var(--pill-badge-yellow-bg)]"
                                    }`}
                                  >
                                    {batch[col.value]}
                                  </span>
                                </div>
                              ) : (
                                batch[col.value] ?? "--"
                              )}
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default BatchSelectionModal;
